import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography } from '@material-ui/core'

import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { RetailerLabel } from 'src/modules/supply_chain/components/retailers/RetailerLabel'

import { GenericCard } from '../ModelCard'
import { LabelPrintingHandler } from 'src/scanRouter/handlers'

interface LabelPrintingDisplayProps {
  handler: LabelPrintingHandler
}

export const LabelPrintingDisplay = (props: LabelPrintingDisplayProps) => {
  const { handler } = props
  const [, refresh] = useState({})
  const { print, renderPrintComponent } = useAsyncPrint()

  useEffect(() => {
    const cb = () => {
      refresh({})
    }
    handler.registerCb(cb)
    return () => handler.removeCb(cb)
  }, [handler, refresh])

  if (!handler.obj?.object || !handler.obj?.object) {
    return null
  }

  return (
    <>
      {renderPrintComponent()}
      <Grid container justify="center">
        <Grid item xs={12}>
          <Typography>Printing labels for...</Typography>
        </Grid>
        <Grid item xs={12}>
          <GenericCard item={handler.obj} />
        </Grid>
        <Grid item xs={12}>
          <Typography>Scan object to print a label for...</Typography>
        </Grid>
        {handler.container && (
          <>
            <Grid item xs={12}>
              <GenericCard item={handler.container} />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  const labelData = handler.container?.object.labelData
                  print((props) => <RetailerLabel data={labelData} {...props} />)
                  handler.printed()
                }}
              >
                Print Label
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </>
  )
}
